import { onSnapshot, applySnapshot } from "mobx-state-tree";

export const persist = (name, store, options = {}) => {
  let { storage, jsonify, shouldPersist } = options;

  onSnapshot(store, (_snapshot) => {
    if (typeof shouldPersist === "function" && !shouldPersist(_snapshot)) {
      return;
    }
    const snapshot = { ..._snapshot };
    const data = !jsonify ? snapshot : JSON.stringify(snapshot);
    try {
      storage.setItem(name, data);
    } catch (error) {
      console.log(error);
    }
  });

  const data = storage.getItem(name);

  if (data) {
    const snapshot = !jsonify ? data : JSON.parse(data);
    applySnapshot(store, snapshot);
  }

  return data;
};
